import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import './BestDeal.css';

const topBrands = [
  { name: 'Omron', icon: '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5"><polygon points="13 2 3 14 12 14 11 22 21 10 12 10 13 2"/></svg>', tag: 'Electronics', href: '/brands/omron' },
  { name: 'Schneider', icon: 'plug', tag: 'Electricals', href: '/brands/schneider-electric' },
  { name: 'Candes', icon: '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5"><path d="M9 18h6"/><path d="M10 22h4"/><path d="M15.09 14c.18-.98.65-1.74 1.41-2.5A4.65 4.65 0 0 0 18 8 6 6 0 0 0 6 8c0 1 .23 2.23 1.5 3.5.76.76 1.23 1.52 1.41 2.5"/></svg>', tag: 'Appliances', href: '/brands/candes' },
  { name: 'Microtek', icon: 'battery', tag: 'Power', href: '/brands/microtek' },
  { name: 'D-Link', icon: 'wifi', tag: 'Networking', href: '/brands/d-link' },
  { name: 'Stanley', icon: '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5"><path d="M14.7 6.3a1 1 0 0 0 0 1.4l1.6 1.6a1 1 0 0 0 1.4 0l3.77-3.77a6 6 0 0 1-7.94 7.94l-6.91 6.91a2.12 2.12 0 0 1-3-3l6.91-6.91a6 6 0 0 1 7.94-7.94l-3.76 3.76z"/></svg>', tag: 'Tools', href: '/brands/stanley' },
  { name: 'DeWalt', icon: '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5"><path d="M14.7 6.3a1 1 0 0 0 0 1.4l1.6 1.6a1 1 0 0 0 1.4 0l3.77-3.77a6 6 0 0 1-7.94 7.94l-6.91 6.91a2.12 2.12 0 0 1-3-3l6.91-6.91a6 6 0 0 1 7.94-7.94l-3.76 3.76z"/></svg>', tag: 'Power Tools', href: '/brands/dewalt' },
  { name: 'Black & Decker', icon: '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5"><circle cx="12" cy="12" r="3"/><path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1-2.83 2.83l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-4 0v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83-2.83l.06-.06A1.65 1.65 0 0 0 4.68 15a1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1 0-4h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 2.83-2.83l.06.06A1.65 1.65 0 0 0 9 4.68a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 4 0v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 2.83l-.06.06A1.65 1.65 0 0 0 19.4 9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 0 4h-.09a1.65 1.65 0 0 0-1.51 1z"/></svg>', tag: 'Tools', href: '/brands/black-decker' },
  { name: 'Shell', icon: '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5"><ellipse cx="12" cy="5" rx="9" ry="3"/><path d="M21 12c0 1.66-4 3-9 3s-9-1.34-9-3"/><path d="M3 5v14c0 1.66 4 3 9 3s9-1.34 9-3V5"/></svg>', tag: 'Lubricants', href: '/brands/shell' },
  { name: 'Kimberly-Clark', icon: 'droplet', tag: 'Cleaning', href: '/brands/kimberly-clark' },
  { name: 'Bosch', icon: 'wrench', tag: 'Engineering', href: '/brands/bosch' },
  { name: 'HP', icon: '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5"><rect x="2" y="3" width="20" height="14" rx="2"/><line x1="8" y1="21" x2="16" y2="21"/><line x1="12" y1="17" x2="12" y2="21"/></svg>', tag: 'IT & Electronics', href: '/brands/hp' },
  { name: 'Epson', icon: '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5"><polyline points="6 9 6 2 18 2 18 9"/><path d="M6 18H4a2 2 0 0 1-2-2v-5a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v5a2 2 0 0 1-2 2h-2"/><rect x="6" y="14" width="12" height="8"/></svg>', tag: 'Printing', href: '/brands/epson' },
  { name: 'Kirloskar', icon: '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5"><circle cx="12" cy="12" r="3"/><path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1-2.83 2.83l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-4 0v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83-2.83l.06-.06A1.65 1.65 0 0 0 4.68 15a1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1 0-4h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 2.83-2.83l.06.06A1.65 1.65 0 0 0 9 4.68a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 4 0v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 2.83l-.06.06A1.65 1.65 0 0 0 19.4 9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 0 4h-.09a1.65 1.65 0 0 0-1.51 1z"/></svg>', tag: 'Pumps', href: '/brands/kirloskar' },
  { name: 'Havells', icon: '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5"><path d="M9 18h6"/><path d="M10 22h4"/><path d="M15.09 14c.18-.98.65-1.74 1.41-2.5A4.65 4.65 0 0 0 18 8 6 6 0 0 0 6 8c0 1 .23 2.23 1.5 3.5.76.76 1.23 1.52 1.41 2.5"/></svg>', tag: 'Electricals', href: '/brands/havells' },
  { name: 'Pristyn Care', icon: 'medical', tag: 'Medical', href: '/brands/pristyn-care' },
];

const categories = [
  {
    title: 'Circuit Breakers & MCCBs',
    subtitle: 'Shop Schneider Electric range',
    icon: '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5"><polygon points="13 2 3 14 12 14 11 22 21 10 12 10 13 2"/></svg>',
    bg: 'linear-gradient(135deg, #1a1a2e 0%, #16213e 100%)',
    href: '/shop',
  },
  {
    title: 'Blood Pressure Monitors',
    subtitle: 'Trusted Omron diagnostics',
    icon: 'medical',
    bg: 'linear-gradient(135deg, #0f3460 0%, #533483 100%)',
    href: '/shop',
  },
  {
    title: 'Geysers & Water Heaters',
    subtitle: 'Candes home appliances',
    icon: 'shower',
    bg: 'linear-gradient(135deg, #e94560 0%, #c0392b 100%)',
    href: '/shop',
  },
  {
    title: 'Voltage Stabilizers',
    subtitle: 'Microtek power solutions',
    icon: 'battery',
    bg: 'linear-gradient(135deg, #0d7377 0%, #14a085 100%)',
    href: '/shop',
  },
  {
    title: 'Cleaning Supplies',
    subtitle: 'Kimberly-Clark essentials',
    icon: 'tool',
    bg: 'linear-gradient(135deg, #373B44 0%, #4286f4 100%)',
    href: '/shop',
  },
  {
    title: 'WiFi Routers & Access Points',
    subtitle: 'D-Link network devices',
    icon: 'wifi',
    bg: 'linear-gradient(135deg, #4a00e0 0%, #8e2de2 100%)',
    href: '/shop',
  },
];

const shopBrands = [
  { name: 'Bosch', icon: 'wrench', href: '/brands/bosch' },
  { name: 'Epson', icon: '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5"><polyline points="6 9 6 2 18 2 18 9"/><path d="M6 18H4a2 2 0 0 1-2-2v-5a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v5a2 2 0 0 1-2 2h-2"/><rect x="6" y="14" width="12" height="8"/></svg>', href: '/brands/epson' },
  { name: 'Neptune', icon: 'droplet', href: '/brands/neptune' },
  { name: 'Sameer', icon: 'wind', href: '/brands/sameer' },
  { name: 'HP', icon: '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5"><rect x="2" y="3" width="20" height="14" rx="2"/><line x1="8" y1="21" x2="16" y2="21"/><line x1="12" y1="17" x2="12" y2="21"/></svg>', href: '/brands/hp' },
  { name: 'Mezonite', icon: '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5"><polygon points="13 2 3 14 12 14 11 22 21 10 12 10 13 2"/></svg>', href: '/brands/mezonite' },
];

const BestDeal: React.FC = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="bestdeal-page">

      {/* ── Hero Banner ──────────────────────────────────────── */}
      <div className="bestdeal-hero">
        <div className="bestdeal-hero-inner">
          <div className="bestdeal-hero-text">
            <div className="bestdeal-hero-badge">
              <span className="bestdeal-hero-badge-dot"></span>
              Live Deals — Updated Daily
            </div>
            <h1>Best Deals &amp;<br /><span>Top Offers</span></h1>
            <p>Handpicked savings from India's leading industrial and consumer brands, all in one place.</p>
            <Link to="/shop" className="bestdeal-hero-cta">Shop All Deals →</Link>
          </div>
          <div className="bestdeal-hero-gift">
            <div className="bestdeal-hero-gift-icon"><svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5"><polyline points="20 12 20 22 4 22 4 12"/><rect x="2" y="7" width="20" height="5"/><line x1="12" y1="22" x2="12" y2="7"/><path d="M12 7H7.5a2.5 2.5 0 0 1 0-5C11 2 12 7 12 7z"/><path d="M12 7h4.5a2.5 2.5 0 0 0 0-5C13 2 12 7 12 7z"/></svg></div>
            <h3>E-Gift Vouchers</h3>
            <p>Send the gift of choice to your teams and partners</p>
            <Link to="/shop" className="bestdeal-hero-gift-btn">Get a Voucher</Link>
          </div>
        </div>
      </div>

      {/* ── Top Brands of the Month ──────────────────────────── */}
      <div className="bestdeal-section">
        <div className="bestdeal-section-header">
          <h2>Top Brands of the Month</h2>
          <div className="underline"></div>
        </div>
        <div className="bestdeal-brands-grid">
          {topBrands.map((brand, idx) => (
            <a key={idx} href={brand.href} className="bestdeal-brand-card">
              <span className="bestdeal-brand-logo">{brand.icon}</span>
              <span className="bestdeal-brand-name">{brand.name}</span>
              <span className="bestdeal-brand-tag">{brand.tag}</span>
            </a>
          ))}
        </div>
      </div>

      {/* ── Shop by Categories ───────────────────────────────── */}
      <div className="bestdeal-section">
        <div className="bestdeal-section-header">
          <h2>Shop by Categories</h2>
          <div className="underline"></div>
        </div>
        <div className="bestdeal-categories-grid">
          {categories.map((cat, idx) => (
            <a
              key={idx}
              href={cat.href}
              className="bestdeal-category-card"
              style={{ background: cat.bg }}
            >
              <span className="bestdeal-category-card-bg">{cat.icon}</span>
              <div className="bestdeal-category-content">
                <h3>{cat.title}</h3>
                <p>{cat.subtitle}</p>
                <span>Shop Now →</span>
              </div>
            </a>
          ))}
        </div>
      </div>

      {/* ── Shop by Brands ───────────────────────────────────── */}
      <div className="bestdeal-section">
        <div className="bestdeal-section-header">
          <h2>Shop by Brands</h2>
          <div className="underline"></div>
        </div>
        <div className="bestdeal-shop-brands">
          {shopBrands.map((brand, idx) => (
            <a key={idx} href={brand.href} className="bestdeal-shop-brand">
              <div className="bestdeal-shop-brand-icon">{brand.icon}</div>
              <div className="bestdeal-shop-brand-name">{brand.name}</div>
            </a>
          ))}
        </div>
      </div>

      {/* ── Bottom CTA Banner ────────────────────────────────── */}
      <div className="bestdeal-bottom-banner">
        <div className="bestdeal-bottom-inner">
          <div>
            <h2>Discover All Brands &amp; Deals</h2>
            <p>Explore 500+ brands across industrial, consumer, and medical categories — all with best-in-class pricing.</p>
          </div>
          <Link to="/shop" className="bestdeal-bottom-cta">Browse All Brands →</Link>
        </div>
      </div>

    </div>
  );
};

export default BestDeal;
